var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import View from "./ui/view";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ContextMenuAFY, IconAFY, icons, sizesIcon, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { CobranzaHeader } from "./ui/header";
import { useGetCollectionReport } from "./useGetCollectionReport";
import { showErrorToast } from "../../fnx/showError";
import { themeCore } from "../../assets/themes/theme";
import LocalStorageService from "../../services/localStorage";
import { getCollections } from "../../resources/helper/collection";
import "./assets/style.css";
import { showToastSuccessMessage } from "../../fnx/sendSuccessMessage";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
var Billing = function () {
    var t = useTranslation().t;
    var _a = React.useState([]), collections = _a[0], setCollections = _a[1];
    var navigate = useNavigate();
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var _c = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _c[0], setSeeToast = _c[1];
    var _d = useGetCollectionReport(), getCollectionReport = _d.getCollectionReport, loadingCollectionReport = _d.loadingCollectionReport, responseCollectionReport = _d.responseCollectionReport, errorCollectionReport = _d.errorCollectionReport;
    var _e = useState(100), count = _e[0], setCount = _e[1];
    var _f = useState(10), rowsPerPages = _f[0], setRowsPerPages = _f[1];
    var _g = useState(1), pagePagination = _g[0], setPagePagination = _g[1];
    var handleOnClickNext = function (data) {
        console.log(data);
    };
    var onClickBack = function () {
        navigate("/");
    };
    var onClickGenerate = function () {
        navigate("/admin/billing");
    };
    var getStatusLabel = function (estado) {
        switch (estado) {
            case "BANK_PAYMENT_PENDING":
                return "En Proceso";
            case "COMPLETED":
                return "Completado";
            case "FAILED":
                return "Fallido";
            case "PROCESSING_BANK_FILE":
                return "Procesando Pagos";
            case "GENERATING_BANK_FILE":
                return "Generando archivo";
            default:
                return estado;
        }
    };
    useEffect(function () {
        if (responseCollectionReport) {
            showToastSuccessMessage("Reporte descargado con éxito", typeAlert.success, setSeeToast);
        }
    }, [responseCollectionReport]);
    useEffect(function () {
        if (errorCollectionReport) {
            showErrorToast(errorCollectionReport, setSeeToast, t, true);
        }
    }, [errorCollectionReport]);
    var formatDate = function (dateString) {
        var date = new Date(dateString);
        var day = String(date.getDate()).padStart(2, "0");
        var month = String(date.getMonth() + 1).padStart(2, "0");
        var year = date.getFullYear();
        return "".concat(day, "/").concat(month, "/").concat(year);
    };
    var fetchCollections = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    setCollections([]);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, getCollections(true, pagePagination, rowsPerPages)];
                case 2:
                    response = _a.sent();
                    if (response) {
                        response.data.map(function (item) {
                            var newItem = {
                                id: item.id,
                                tipo: "Recepción de pagos",
                                estado: getStatusLabel(item.status),
                                status: item.status,
                                completionSummary: item.completionSummary,
                                usuario: item.parameters.userName,
                                fecha: formatDate(item.createdAt),
                                archivos: item.batchFiles.length,
                                children: item.batchFiles.length > 0 && [
                                    {
                                        id: "5.1",
                                        tipo: "Detalles",
                                        estado: "",
                                        usuario: "",
                                        fecha: "",
                                        archivos: 0,
                                        referencia: "",
                                        detalles: item.batchFiles.map(function (file) { return file.url; }),
                                        actionText: "Descargar Archivos",
                                    },
                                ],
                            };
                            setCollections(function (prev) { return __spreadArray(__spreadArray([], prev, true), [newItem], false); });
                        });
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error("Error fetching collections:", error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var downloadFiles = function (e) {
        var fileUrl = e.detalles; //
        if (Array.isArray(fileUrl) && fileUrl.length > 0) {
            fileUrl.forEach(function (url) {
                var link = document.createElement("a");
                link.href = url;
                link.download = url.split("/").pop() || "file";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
        }
        else {
            console.error("No se puede descargar el archivo. URL no válida o vacía.");
        }
    };
    var onChangePage = function (page) {
        setPagePagination(page);
    };
    var onChangeRowsPerPage = function (rows) {
        setRowsPerPages(rows);
        setPagePagination(1);
        //setRowsPerPages(rows);
    };
    useEffect(function () {
        fetchCollections();
    }, [pagePagination]);
    var getMenuItems = function (row) {
        var _a;
        var items = [
            { disabled: false, id: "1", name: "Ver Detalles" },
            { disabled: false, id: "2", name: "Aplicar Pagos" },
        ];
        if (row.status === "COMPLETED" && !!((_a = row.completionSummary) === null || _a === void 0 ? void 0 : _a.report)) {
            items.push({
                disabled: false,
                id: "3",
                name: "Reporte de pagos y rechazos",
            });
        }
        return items;
    };
    return (_jsxs(React.Fragment, { children: [_jsx(CobranzaHeader, { loading: loading || loadingCollectionReport, seeToast: seeToast, setSeeToast: setSeeToast }), _jsx(View, { onClickNext: handleOnClickNext, title: "Cobranza", data: collections, count: count, pagePagination: pagePagination, rowsPerPages: rowsPerPages, onChangePage: onChangePage, onChangeRowsPerPage: onChangeRowsPerPage, columns: [
                    {
                        accessorKey: "actions",
                        header: "",
                        size: 50,
                        enableResizing: false,
                        cell: function (_a) {
                            var row = _a.row;
                            return (_jsx(ContextMenuAFY, { colorButton: "transparent", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: getMenuItems(row.original), onClickContextMenu: function (item) {
                                    if (item.id === "1") {
                                        navigate("/admin/billing", {
                                            state: {
                                                id: row.original.id,
                                                tipo: row.original.tipo,
                                                estado: row.original.estado,
                                                usuario: row.original.usuario,
                                                fecha: row.original.fecha,
                                                archivos: row.original.archivos,
                                                referencia: row.original.referencia,
                                                readOnly: true,
                                            },
                                        });
                                    }
                                    if (item.id === "2") {
                                        navigate("/admin/collect", {
                                            state: {
                                                id: row.original.id,
                                                tipo: row.original.tipo,
                                                estado: row.original.estado,
                                                usuario: row.original.usuario,
                                                fecha: row.original.fecha,
                                                archivos: row.original.archivos,
                                                referencia: row.original.referencia,
                                            },
                                        });
                                    }
                                    if (item.id === "3") {
                                        getCollectionReport(row.original.id);
                                    }
                                }, sizeIcon: sizesIcon.standard }));
                        },
                    },
                    {
                        accessorKey: "id",
                        header: "",
                        cell: function (_a) {
                            var _b;
                            var row = _a.row;
                            var hasChildren = ((_b = row.original.children) === null || _b === void 0 ? void 0 : _b.length) > 0;
                            return (_jsx("div", __assign({ style: { paddingLeft: "".concat(row.depth * 20, "px") }, className: "cell" }, { children: hasChildren && (_jsx("button", __assign({ className: "expand-btn", onClick: function () { return row.toggleExpanded(); } }, { children: row.getIsExpanded() ? (_jsx(IconAFY, { icon: icons.KeyboardArrowUp })) : (_jsx(IconAFY, { icon: icons.KeyboardArrowDown })) }))) })));
                        },
                    },
                    {
                        accessorKey: "tipo",
                        header: "Tipo",
                    },
                    {
                        accessorKey: "estado",
                        header: "Estado",
                    },
                    {
                        accessorKey: "usuario",
                        header: "Usuario",
                    },
                    {
                        accessorKey: "fecha",
                        header: "Fecha de Creación",
                    },
                    {
                        accessorKey: "archivos",
                        header: "Archivos",
                    },
                ], onClickGenerate: onClickGenerate, onClickDownload: function (e) {
                    downloadFiles(e);
                }, backgroundColorBack: themeCore.colors.primary, backgroundColorNext: themeCore.colors.primary, onClickRefresh: function () {
                    fetchCollections();
                }, onClickBack: onClickBack, next: {
                    nextLabel: "",
                    previousLabel: "",
                    nextDisabled: false,
                } })] }));
};
export default Billing;
